export const pmFieldsMarkedAsRequired: string[] = [
  'supervisionTypePm',
  'pmType',
  'startDate',
  'officialFullName',
  'pmSignerPosition',
  'signers',
  'signers[{id}].fioSigner',
  'signers[{id}].titleSigner',
  'reasonsPm',
  'subjectTypePm',
  'reasonsPm[{id}].type',
  'reasonsPm[{id}].riskIndicators',
  'reasonsPm[{id}].riskIndicators[{id}].riskIndicator',
  'reasonsPm[{id}].riskIndicators[{id}].indicatorRiskAttachment',
  'reasonsPm[{id}].riskIndicators[{id}].indicatorRiskAuto',
  'reasonsPm[{id}].text',
  'reasonsPm[{id}].dateRequirement',
  'reasonsPm[{id}].requirementDetails',
  'reasonsPm[{id}].order',
  'reasonsPm[{id}].links',
  'reasonsPm[{id}].date',
  'reasonsPm[{id}].lastConductedKnmDate',
  'reasonsPm[{id}].assignmentDate',
  'reasonsPm[{id}].assignmentNumber',
  'reasonsPm[{id}].fullName',
  'reasonsPm[{id}].programNumber',
  'reasonsPm[{id}].programAttachment',
  'reasonsPm[{id}].prosecutorAttachment',
  'reasonsPm[{id}].prescriptionDate',
  'reasonsPm[{id}].prescriptionNumber',
  'reasonsPm[{id}].planKnm',
  'act.typeAct',
  'act.organizationTemplate',
  'act.organization.subjectType',
  'subjectType',
  'act.organization.inn',
  'inn',
  'act.organization.organizationName',
  'organizationName',
  'act.organization.snils',
  'snils',
  'act.organization.kpp',
  'kpp',
  'act.organization.rafpNza',
  'rafpNza',
  'act.organization.country',
  'country',
  'act.organization.document',
  'document',
  'act.canceledReason',
  'act.canceledReasonDescription',
  'act.canceledReasonDescriptionReactQuillEditor',
  'act.document.attachments',
  'act.events',
  'act.events[{id}].type',
  'act.events[{id}].startDate',
  'act.events[{id}].stopDate',
  'act.events[{id}].linkVks',
  'act.events[{id}].inspectors',
  'act.events[{id}].inspectors[{id}].fullName',
  'act.events[{id}].protocol.file.attachments',
  'act.events[{id}].uavTechnologies',
  'act.events[{id}].uavTechnologies[{id}].type',
  'act.events[{id}].uavTechnologies[{id}].name',
  'act.isViolatedMandatoryRequirements',
  'act.violatedMandatoryRequirements',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].category',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].title',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].descriptionReactQuillEditor',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type[{id}].value',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments[{id}].link.value',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].events',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].events[{id}].eventOption',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].events[{id}].materials',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].events[{id}].materials[{id}].typeDocConfirmationViolation',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].events[{id}].materials[{id}].links',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].events[{id}].materials[{id}].links[{id}].value',
  'act.violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].events[{id}].materials[{id}].attachments',
  'act.isViolationResolvedNote',
  'act.fioReader',
  'act.titleReader',
  'act.knoInspectors',
  'act.knoInspectors[{id}].knoInspector',
  'act.acquaintanceLackType',
  'act.fioAndPositionSinger',
  'act.signers',
  'act.signers[{id}].fioSigner',
  'act.signers[{id}].titleSigner',
  'act.holdingDateTime',
  'act.durationDays',
  'act.durationHours',
  'act.refuserFio',
  'act.refuserTitle',
  'act.familiarizationNotifications',
  'act.familiarizationNotifications[{id}].knmNoticeType',
  'act.familiarizationNotifications[{id}].noticeDate',
  'act.remarks[{id}].text',
  'act.remarks[{id}].textReactQuillEditor',
  'act.remarks[{id}].signerFullName',
  'act.remarks[{id}].signerPosition',
  'act.remarks[{id}].date',
  'eventsPm',
  'eventsPm[{id}].type',
  'eventsPm[{id}].interactionCategory',
  'eventsPm[{id}].startDate',
  'eventsPm[{id}].stopDate',
  'eventsPm[{id}].submittedDocuments[{id}].documentTitle',
  'eventsPm[{id}].submittedDocuments[{id}].requestDateTime',
  'eventsPm[{id}].submittedDocuments[{id}].submissionDeadline',
  'eventsPm[{id}].submittedDocuments[{id}].submissionDateTime',
  'eventsPm[{id}].submittedDocuments[{id}].files',
  'eventsPm[{id}].uavTechnologies',
  'eventsPm[{id}].uavTechnologies[{id}].type',
  'eventsPm[{id}].uavTechnologies[{id}].name',
  'videoCallInfo',
  'videoCallInfo[{id}].link',
  'videoCallInfo[{id}].dateTime',
  'pmResultDecisions[{id}].information',
  'pmResultDecisions[{id}].violatedMandatoryRequirements',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].category',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanMethodsRequired',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanDates[{id}].value',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixPlanExplanationsRequired',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].title',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'pmResultDecisions[{id}].violatedMandatoryRequirements[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'pmResultDecisions[{id}].signerFullName',
  'pmResultDecisions[{id}].signerPosition',
  'pmResultDecisions[{id}].signers',
  'pmResultDecisions[{id}].signers[{id}].fioSigner',
  'pmResultDecisions[{id}].signers[{id}].titleSigner',
  'pmResultDecisions[{id}].subject.inn',
  'pmResultDecisions[{id}].subject.organizationName',
  'pmResultDecisions[{id}].subject.country',
  'pmResultDecisions[{id}].founder.subjectTypePm',
  'pmResultDecisions[{id}].founder.inn',
  'pmResultDecisions[{id}].founder.snils',
  'pmResultDecisions[{id}].founder.organizationName',
  'pmResultDecisions[{id}].founder.country',
  'pmResultDecisions[{id}].familiarizationNotifications',
  'pmResultDecisions[{id}].familiarizationNotifications[{id}].knmNoticeType',
  'pmResultDecisions[{id}].familiarizationNotifications[{id}].noticeDate',
  'agreements[{id}].prescription',
  'agreements[{id}].prescription',
  'agreements[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixFactMethod',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].type[{id}].value',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterial',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].explanationMaterialReactQuillEditor',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].method',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].attachments[{id}].link.value',
  'agreements[{id}].violations[{id}].violatedMandatory[{id}].violations[{id}].fixes[{id}].grade',
  'agreements[{id}].petitionOrganizationType',
  'agreements[{id}].petitionAttachment',
  'agreements[{id}].petitionOrganization.inn',
  'agreements[{id}].petitionOrganization.ogrn',
  'agreements[{id}].petitionOrganization.snils',
  'agreements[{id}].petitionOrganization.subjectType',
  'agreements[{id}].petitionOrganization.organizationName',
  'agreements[{id}].petitionOrganization.factualAddress',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].petitionOrganization.country',
  'agreements[{id}].petitionOrganization.rafpNza',
  'agreements[{id}].petitionOrganization.kpp',
  'agreements[{id}].petitionOrganization.document',
  'agreements[{id}].petitionOrganization.locationAddress',
  'agreements[{id}].approvalOfAgreement',
  'agreements[{id}].approvalOfAgreementAttachment',
  'agreements[{id}].eliminateViolationsNumber',
  'agreements[{id}].conclusionDate',
  'agreements[{id}].termOfExecutionAgreement',
  'agreements[{id}].eliminateViolationsAttachment',
  'agreements[{id}].applicationForConsiderationAttachment',
  'agreements[{id}].violationCorrectionProgramAttachments',
  'agreements[{id}].prosecutorOrganization',
  'agreements[{id}].fioSigner',
  'agreements[{id}].titleSigner',
  'agreements[{id}].approveInfo.note',
  'agreements[{id}].approveInfo.approved',
  'agreements[{id}].approveInfo.numberDecision',
  'agreements[{id}].approveInfo.dateDecision',
  'agreements[{id}].approveInfo.whoMadeDecision',
  'agreements[{id}].approveInfo.titleSigner',
  'agreements[{id}].approveInfo.attachment',
  'agreements[{id}].terminate.terminationReasons',
  'agreements[{id}].terminate.decisionTerminationAttachment',
  'agreements[{id}].terminate.titleSigner',
  'agreements[{id}].terminate.titleSigner.label',
  'agreements[{id}].terminate.fioSigner',
  'agreements[{id}].execution.decision',
  'agreements[{id}].execution.executionDate',
  'agreements[{id}].execution.titleSigner',
  'agreements[{id}].execution.fioSigner',
  'agreements[{id}].changes[{id}].types',
  'agreements[{id}].changes[{id}].types[{id}].type',
  'agreements[{id}].changes[{id}].reasons',
  'agreements[{id}].changes[{id}].reasons[{id}]',
  'agreements[{id}].changes[{id}].attachment',
  'agreements[{id}].changes[{id}].termOfExecutionAgreement',
  'agreements[{id}].changes[{id}].updatedAgreementAttachment',
  'agreements[{id}].changes[{id}].petitionAttachment',
  'agreements[{id}].changes[{id}].titleSigner',
  'agreements[{id}].changes[{id}].fioSigner',
  'interactionCategory',
  'objectsPm',
  `objectsPm[{id}].address`,
  `objectsPm[{id}].objectType`,
  `objectsPm[{id}].objectKind`,
  `objectsPm[{id}].objectSubKind`,
  'inspectorsErknm',
  'inspectorsErknm[{id}].fullName',
  'inspectorsErknm[{id}].position',
  'experts[{id}].title',
  'experts[{id}].type',
  'subjectNotifications[{id}].type',
  'subjectNotifications[{id}].date',
  'subjectNotifications[{id}].comment',
  'takenMeasures',
  'noteWarningReactQuillEditor',
];
